import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import 'rxjs/add/operator/toPromise';
import config from '../../../config';
import {Mail} from "../../../classes/mail";

@Injectable()
export class kanMailsService {
    constructor(private http: HttpClient) {
    }

    public getMails(): Promise<Mail[]> {
        return new Promise((resolve, reject) => {
            let filter = {
                where: {
                    type: 'MAILING'
                }
            };
            let params = new HttpParams().set('filter', JSON.stringify(filter));
            this.http.get(`${config.apiRootUrl}/api/mails`, {params: params})
                .toPromise()
                .then((response: any) => {
                    let mails = response.map((item) => {
                        item.sentDate = item.sentDate ? new Date(item.sentDate) : null;
                        return item;
                    });
                    resolve(mails as Mail[]);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    public getBirthdayMail(): Promise<Mail> {
        return new Promise((resolve, reject) => {
            let filter = {
                where: {
                    type: 'BIRTHDAY'
                }
            };
            let params = new HttpParams().set('filter', JSON.stringify(filter));
            this.http.get(`${config.apiRootUrl}/api/mails`, {params: params})
                .toPromise()
                .then((response: any) => {
                    resolve(response[0] as Mail);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    public getRenewalMail(): Promise<Mail> {
        return new Promise((resolve, reject) => {
            let filter = {
                where: {
                    type: 'RENEWAL'
                }
            };
            let params = new HttpParams().set('filter', JSON.stringify(filter));
            this.http.get(`${config.apiRootUrl}/api/mails`, {params: params})
                .toPromise()
                .then((response: any) => {
                    resolve(response[0] as Mail);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    public addMail(mail: any): Promise<Mail> {
        return new Promise((resolve, reject) => {
            this.http.post(`${config.apiRootUrl}/api/mails`, mail)
                .toPromise()
                .then((response: any) => {
                    resolve(response as Mail);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    public updateMail(mail: Mail): Promise<Mail> {
        return new Promise((resolve, reject) => {
            this.http.patch(`${config.apiRootUrl}/api/mails/${mail.id}`, mail)
                .toPromise()
                .then((response: any) => {
                    resolve(response as Mail);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    public removeMail(mail: Mail): Promise<boolean> {
        return new Promise((resolve, reject) => {
            this.http.delete(`${config.apiRootUrl}/api/mails/${mail.id}`, {})
                .toPromise()
                .then((response: any) => {
                    resolve();
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    public sendMail(mail: Mail): Promise<boolean> {
        return new Promise((resolve, reject) => {
            this.http.post(`${config.apiRootUrl}/api/mails/${mail.id}/send`, {})
                .toPromise()
                .then((response: any) => {
                    resolve();
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }
}



// WEBPACK FOOTER //
// ./src/modules/services/services/mails.ts